<template functional>
  <b-card class="card-box overflow-hidden">
    <template v-slot:header>
      <div class="">
        <h4 class="card-box_header">
          {{ props.title }}
        </h4>
      </div>
    </template>
    <div class="card-box_body">
      <slot name="body" />
    </div>
  </b-card>
</template>

<script>
export default {
  name: 'CardBox',
  props: {
    title: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped lang="scss">
@import '../../../sass/v3.scss';
.card-box {
  flex: 1;
  border: none;
  border-radius: 0;
  background-color: transparent;
  &_body {
    margin-top: 1rem;
    padding: 1.5rem;
    border: 1px solid rgba($v3_color_black_knight, 0.3);
    border-radius: 0;
  }
  &_header {
    @extend .font_size_1000rem;
  }
}
</style>
